import { render } from "./speaking-engagement.vue?vue&type=template&id=961393a2&scoped=true"
import script from "./speaking-engagement.vue?vue&type=script&lang=js"
export * from "./speaking-engagement.vue?vue&type=script&lang=js"

import "./speaking-engagement.vue?vue&type=style&index=0&id=961393a2&scoped=true&lang=css"

import exportComponent from "/Users/suniyl/Documents/work/shopify-projects/behno/behno-us-version-3/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-961393a2"]])

export default __exports__